import {useCallback} from 'react';

import {DEFAULT_LOCALE} from 'src/constants';
import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountDefaultLocale} from 'src/openapi/admin/apis/GetAccountDefaultLocaleApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useDefaultFormatSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccountDefaultLocale({accountId}),
    ), [accountId, apiDispatch]);

    return useReadOnlyDataHook({
        getDispatchAction,
        initValue: DEFAULT_LOCALE,
    });
};
